export function sectionData(home, key, fallback) {
  const section = home?.[key]
  return section?.status === 'ready' ? section.data : fallback
}

export function displayDate(value, language = 'en', options = {}) {
  if (!value) return '—'
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00`)
  if (Number.isNaN(date.getTime())) return String(value)
  return new Intl.DateTimeFormat(language === 'cn' ? 'zh-CN' : 'en-US', {
    month: 'short', day: 'numeric', weekday: options.weekday ? 'short' : undefined,
  }).format(date)
}

export function displayMoney(cents, language = 'en') {
  return new Intl.NumberFormat(language === 'cn' ? 'zh-CN' : 'en-US', {
    style: 'currency', currency: 'CNY', maximumFractionDigits: 2,
  }).format(Number(cents || 0) / 100)
}

export function displayHours(minutes) {
  const value = Number(minutes || 0) / 60
  return `${Number.isInteger(value) ? value : value.toFixed(1)}h`
}

export function createMutationId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID()
  return `portal-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export function sessionsForClass(schedule, classId) {
  return [
    ...(schedule?.upcoming_sessions || []),
    ...(schedule?.past_sessions || []),
  ].filter((row) => row.class_id === classId)
}

export function studentsForClass(schedule, classId) {
  return (schedule?.students || []).filter((row) => row.class_id === classId)
}
